import { css } from '@linaria/core';
export const docsCard = "odules__Home__cards__Docs_styles_ts-docsCard-d5dw648";
export const docsCardTitleWrapper = "odules__Home__cards__Docs_styles_ts-docsCardTitleWrapper-d17jbzfm";
export const docsCardTitle = "odules__Home__cards__Docs_styles_ts-docsCardTitle-d11rzxzq";
export const docsCardDescription = "odules__Home__cards__Docs_styles_ts-docsCardDescription-dztljo5";
export const divider = "odules__Home__cards__Docs_styles_ts-divider-d2qrwi4";
export const docsCardLinksWrapper = "odules__Home__cards__Docs_styles_ts-docsCardLinksWrapper-d1ts3unq";

require("./Docs.styles.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./Docs.styles.ts");